import { withApnBesideYearBuilt } from '../../../shared';
import type { TenantLocaleOverrides } from '../base';

export const NVOverrides: TenantLocaleOverrides = {
  locale: 'NV',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: withApnBesideYearBuilt,
          fields: {
            mlsAutofill: {
              action: {
                props: (props) =>
                  props.map((prop) => {
                    if (prop.from === 'property.assessorParcelNumber') {
                      return {
                        ...prop,
                        to: 'property.assessorParcelNumber',
                      };
                    }
                    return prop;
                  }),
              },
            },
            assessorParcelNumber: {
              name: 'property.assessorParcelNumber',
              entity: 'property',
              type: 'text',
              label: 'APN Number',
              placeholderText: '',
            },
          },
        },
      },
    },
  },
};
